import styles from "./Page.module.css";

interface PageProps {
  children: React.ReactNode;
}

const Page: React.FC<PageProps> = ({ children }) => (
  <div className={styles.pageContainer}>{children}</div>
);

export default Page;
